export class ProductFamily {
  productFamilyID: number;
  productFamilyDesc: string;
  productFamilyName: string;
  isActive: boolean;
  imageUrl: string;
  productLines: string;
  image: any;
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/productfamily/productfamily.model.ts